import api from "../services/api"; // this should be your axios instance

// 🔹 POST – Create a new complaint
export const createComplaint = async (complaintData) => {
  const response = await api.post("/Complaints", complaintData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
};

// Get all complaints
export const getAllComplaints = async () => {
  const response = await api.get("/Complaints");
  return response.data;
};

// Get single complaint by ID
export const getComplaintById = async (id) => {
  const response = await api.get(`/Complaints/${id}`);
  return response.data;
};

// Update complaint (PUT)
export const updateComplaint = async (id, complaintData) => {
  // complaintData should match ComplaintUpdateDto
  const response = await api.put(`/Complaints/${id}`, complaintData);
  return response.data;
};

// Delete complaint
export const deleteComplaint = async (id) => {
  const response = await api.delete(`/Complaints/${id}`);
  return response.data;
};

// Download file by filename
export const downloadFile = async (fileName) => {
  const response = await api.get(`/Complaints/files/${fileName}`, {
    responseType: "blob", // important for binary data
  });
  return response.data;
};

export const getComplaintByApplicationId = async (applicationId) => {
  const response = await api.get(`/Complaints/application/${applicationId}`);
  return response.data;
};